import { Recruiter } from './recruiter';

export class RecruiterResponse {
    public sessionValid?: any;
    public errorCode?: any;
    public errorMessage?: any;
    public errorMessageData?: any;
    public verificationResult?: any;
    public appExpiry?: any;
    public profileStrengthInfo?: any;
    public resultSize: number = 0;
    public resultPage: number = 0;
    public resultCount: number = 0;
    public recruiterList: Recruiter[] = [];
}
